import { get, post } from '@/helpers/httpHandler';
import { cloneDeep } from 'lodash';

export default {
  getItemsList: ({ commit }, { params } = {}) => {
    return get('/inhabitant-changes', {
      ...params.filters,
      ...params.paginationOptions
    }).then(response => {
      commit('setFilters', cloneDeep(params.filters));
      commit('setPaginationOptions', cloneDeep(params.paginationOptions));

      return response;
    });
  },

  getById: (_, id) => get(`/inhabitant-changes/${id}/show`),

  storeById: (_, data) =>
    post(`/inhabitant-changes/${data.id}/store-person`, data),

  getStatuses: ({ commit }) =>
    get(`/inhabitant-changes/statuses`).then(response => {
      commit('setInhabitantChangeStatuses', response.data);

      return response;
    }),

  getSources: ({ commit }) =>
    get(`/inhabitant-changes/sources`).then(response => {
      commit('setInhabitantChangeSources', response.data);

      return response;
    }),

  getTypes: ({ commit }) =>
    get(`/inhabitant-changes/types`).then(response => {
      commit('setInhabitantChangeTypes', response.data);

      return response;
    }),

  resolveRequest: (_, { id, data }) =>
    post(`/inhabitant-changes/${id}/resolve`, data)
};
